export const TABLE_UPDATE = "ORGANISATIONS/TABLE_UPDATE";
export const FETCH_SUCCESS = "ORGANISATIONS/FETCH_SUCCESS";

const types = {
    DESTROY_FAILED: "ORGANISATIONS/DESTROY_FAILED",
    DESTROY_REQUEST: "ORGANISATIONS/DESTROY_REQUEST",
    DESTROY_SUCCESS: "ORGANISATIONS/DESTROY_SUCCESS",

    FETCH_FAILED: "ORGANISATIONS/FETCH_FAILED",
    FETCH_REQUEST: "ORGANISATIONS/FETCH_REQUEST",
    FETCH_SUCCESS,

    FETCH_ALL_FAILED: "ORGANISATIONS/FETCH_ALL_FAILED",
    FETCH_ALL_REQUEST: "ORGANISATIONS/FETCH_ALL_REQUEST",
    FETCH_ALL_SUCCESS: "ORGANISATIONS/FETCH_ALL_SUCCESS",

    GET_FAILED: "ORGANISATIONS/GET_FAILED",
    GET_REQUEST: "ORGANISATIONS/GET_REQUEST",
    GET_SUCCESS: "ORGANISATIONS/GET_SUCCESS",

    PATCH_FAILED: "ORGANISATIONS/PATCH_FAILED",
    PATCH_REQUEST: "ORGANISATIONS/PATCH_REQUEST",
    PATCH_SUCCESS: "ORGANISATIONS/PATCH_SUCCESS",
    
    STORE_FAILED: "ORGANISATIONS/STORE_FAILED",
    STORE_REQUEST: "ORGANISATIONS/STORE_REQUEST",
    STORE_SUCCESS: "ORGANISATIONS/STORE_SUCCESS",

    UPDATE_FAILED: "ORGANISATIONS/UPDATE_FAILED",
    UPDATE_REQUEST: "ORGANISATIONS/UPDATE_REQUEST",
    UPDATE_SUCCESS: "ORGANISATIONS/UPDATE_SUCCESS",
    TABLE_UPDATE,
};

export default types;
